import * as Icons from "lucide-react";
import { Reveal, RevealStagger, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";
import { LOCATION_ADVANTAGES } from "@/constants/content";
import { ImageDisclaimer } from "@/components/ImageDisclaimer";

export const Location = () => (
  <section id="location" className="cp-section cp-section--white" data-testid="location-section">
    <div className="cp-container">
      <Reveal className="cp-section-head">
        <span className="cp-eyebrow">Location Advantages</span>
        <h2 className="cp-h2">Sector 10A, Kharkhoda — At The Centre of It All</h2>
      </Reveal>

      <Reveal delay={0.1} className="cp-location-map">
        <img
          src="/brochure/location-map.png"
          alt="Central Plaza location and connectivity map, Sector 10A Kharkhoda"
          loading="lazy"
        />
      </Reveal>
      <ImageDisclaimer />

      <RevealStagger className="cp-location-grid" stagger={0.06}>
        {LOCATION_ADVANTAGES.map((l) => {
          const Icon = Icons[l.icon] || Icons.MapPin;
          return (
            <motion.div key={l.label} variants={revealItem} className="cp-location-item" data-testid={`location-item-${l.label.replace(/\s|\./g, "-").toLowerCase()}`}>
              <Icon size={18} strokeWidth={1.6} />
              <div>
                <strong>{l.value}</strong>
                <span>{l.label}</span>
              </div>
            </motion.div>
          );
        })}
      </RevealStagger>
    </div>
  </section>
);
